import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function HealthBlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {


    axios.get(process.env.REACT_APP_API_BASE_URL + "/healthblogs")
      .then(response => {
        setBlogs(response.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blog posts. Please try again later.");
        setLoading(false);
      });
  }, []);

  // Helper function to format dates nicely (e.g., "August 5, 2025")
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section text-center">
        <div className="container">
          <h1 className="display-4 fw-bold" style={{ fontSize: '2.5rem' }}>
            Health Blog
          </h1>
          <p className="lead" style={{ fontSize: '1.1rem' }}>Your guide to a healthy and joyful life.</p>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-5">
        <div className="container">

          {/* Loading State */}
          {loading && (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading articles...</p>
            </div>
          )}

          {/* Error State */}
          {error && (
            <div className="alert alert-danger text-center my-5" role="alert">
              {error}
            </div>
          )}

          {/* Content Grid */}
          {!loading && !error && (
            <div className="row g-4">
              {blogs.length > 0 ? (
                blogs.map((blog) => (
                  <div key={blog._id} className="col-lg-4 col-md-6">
                    <div className="card blog-card shadow-sm h-100 border-0">
                      {/* Image Handling */}
                      <img
                        src={
                          blog.image.startsWith('http')
                            ? blog.image
                            : `/images/health/${blog.image}`
                        }
                        className="card-img-top"
                        alt={blog.title}
                        style={{ height: '220px', objectFit: 'cover' }}
                        // Fallback image if the specific file isn't found
                        onError={(e) => { e.target.src = "https://via.placeholder.com/400x220?text=Health+Image"; }}
                      />

                      <div className="card-body d-flex flex-column">
                        {/* Date */}
                        <p className="blog-date text-muted small mb-2">
                          {formatDate(blog.date)}
                        </p>

                        <h5 className="blog-title fw-bold text-dark">{blog.title}</h5>

                        <p className="card-text text-secondary flex-grow-1">
                          {/* Truncate description if it's too long */}
                          {blog.description.length > 100
                            ? `${blog.description.substring(0, 100)}...`
                            : blog.description}
                        </p>

                        <div className="mt-3">
                          <Link to={`/health-blog/${blog._id}`} className="btn btn-primary btn-sm">Read More</Link>                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center w-100">
                  <p className="text-muted">No blog posts found.</p>
                </div>
              )}
            </div>
          )}

        </div>
      </section>
    </>
  );
}

export default HealthBlogPage;